import { IconNames } from '@blueprintjs/icons';
import { ActionButtonText, Button } from '@strata/react-buttons';
import { ReasonInput } from '@strata/react-compound-inputs';
import { DialogWithForm } from '@strata/react-dialog';
import { SuccessToast } from '@strata/react-toast-message';
import { Formik, useFormikContext } from 'formik';
import PropTypes from 'prop-types';
import { useState } from 'react';
import * as Yup from 'yup';

import { UserType } from 'services/constants';
import { handleError } from 'services/ErrorManagement';
import { httpDelete } from 'services/Http';

export const DeleteUserDialog = ({ userType, onDeleteSuccess }) => {
    const userFormik = useFormikContext();
    const { upn } = userFormik.values;
    const [isOpen, setIsOpen] = useState(false);
    return (
        <>
            <Formik
                initialValues={{ ...ReasonInput.initialValues }}
                enableReinitialize
                validationSchema={Yup.object({
                    ...ReasonInput.validationSchema,
                })}
                onSubmit={async (values) => {
                    try {
                        const { reason, source } = ReasonInput.submitValues(values);

                        const sourceParamStr = source ? `&source=${source}` : '';
                        await httpDelete(
                            `/authorization/${userType}_users/${upn}?reason=${reason}${sourceParamStr}`,
                        );

                        setIsOpen(false);
                        SuccessToast({ message: `User: ${upn} deleted successfully.` });
                        onDeleteSuccess();
                    } catch (err) {
                        handleError('Error deleting user.', err);
                    }
                }}
            >
                {(formik) => (
                    <DialogWithForm
                        dialogTitle="Delete User"
                        headerIcon={IconNames.WARNING_SIGN}
                        isOpen={isOpen}
                        primaryButtonLabel="Yes, Delete"
                        primaryButtonIntent={Button.Intent.DANGER}
                        isPrimaryButtonDisabled={
                            !(formik.dirty && formik.isValid) || formik.isSubmitting
                        }
                        secondaryButtonLabel="No, Cancel"
                        onSecondaryButtonClick={(e) => {
                            formik.handleReset(e);
                            setIsOpen(false);
                        }}
                        dialogContent={
                            <>
                                <p className="margin__bottom--medium">
                                    Are you sure you want to delete this user?
                                </p>
                                <p className="margin__bottom--medium font-semi-bold">{upn}</p>
                                <ReasonInput
                                    reasons={[
                                        'Inactivity',
                                        'Payer Requested',
                                        'Pharmacy Requested',
                                        'Prescriber Practice Requested',
                                        'Troubleshooting',
                                    ]}
                                />
                            </>
                        }
                    />
                )}
            </Formik>
            <ActionButtonText
                label="Delete User"
                leftIcon={IconNames.TRASH}
                onClick={() => setIsOpen(true)}
            />
        </>
    );
};

DeleteUserDialog.propTypes = {
    userType: PropTypes.oneOf(Object.values(UserType)).isRequired,
    onDeleteSuccess: PropTypes.func.isRequired,
};
